module.exports = __webpack_public_path__ + "static/media/sch-6.868b2eba.jpg";